import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { InputControlBase } from './../forms/input-control.base';

/** @deprecated Use `astral-input type="password"` in new or Astralized templates. */
@Component({
    selector: 'app-password',
    templateUrl: './password.component.html',
    styleUrls: ['./password.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PasswordComponent extends InputControlBase {
  constructor() {
    super();
  }

  showAddonHelp = false;

  @Input() autocomplete = 'off';

  onAddonMouseEnter() {
    this.showAddonHelp = true;
  }

  onAddonMouseLeave() {
    this.showAddonHelp = false;
  }
}
